import React, { Component } from 'react'
import { Form } from 'react-bootstrap'
import {Link, NavLink} from 'react-router-dom'
import './style.css'
export class Home extends Component {
  componentDidMount(){
    // window.location.reload();
  }
    render() {
        return (
            <div>
                
  <div className="section is-hero position-relative bg-hero2 overflow-hidden md-sm-xs-no-padding-bottom flexv-justify-center">
    <div className="decoration-rightside img-hero2"><img src="http://detheme.com/templates/quaid/images/frame.svg" alt="" className="bg-hero-decor"/></div>
    <div data-w-id="bfddaba7-bdf9-7caf-a9f9-b00b1d0a3a8a" style={{WebkitTransform:"translate3d(100PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(100PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(100PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(100PX, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",opacity:0,filter:"blur(5px)"}} className="decoration-rightside img-hero2"><img src="http://detheme.com/templates/quaid/images/men-2.png" alt="" className="hero-image"/></div>
    <div className="container position-relative">
      <div data-w-id="8708aa6a-d8d4-e3ac-bb7f-f062078774e3" style={{WebkitTransform:"translate3d(0, 100PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 100PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 100PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 100PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",opacity:0,filter:"blur(5px)"}} className="col lg-9 md-12">
        <h1 className="c-herotext__main">Tailored Finance for Best Growth</h1>
        <div className="color-dark text-medium margin-bottom">We believe financial advice is about more than just having a plan. It’s about having the right plan for you.</div>
        <Link data-w-id="cf285295-027b-25e0-3964-b91a419e5388" to="/" className="button-primary animated w-inline-block">
          <div style={{WebkitTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",opacity:1}} className="button-primary-text">free consultation</div>
          <div style={{opacity:0,"display":"block",WebkitTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"}} className="button-primary-text for-hover">let&#x27;s go <span className="fa margin-left"></span></div>
        </Link>
      </div>
      <div className="col lg-7 no-margin-bottom-lg"></div>
    </div><img src="http://detheme.com/templates/quaid/images/header2.svg" alt="" className="header-image style-3"/></div>
  <div className="section">
    <div className="container flex-horizontal">
      <div className="col lg-4 flexv-space-between md-12">
        <div>
          <div className="pre-title">Who we are</div>
          <div className="size-h2 margin-bottom">At Financia advisor we&#x27;re all about you, so you can be about your business</div>
          <div className="text-medium low-text-contrast">Nulla vitae elit libero, a pharetra augue. Aenean lacinia bibendum nulla sed consectetur.</div>
        </div><Link to="/" className="cta-link"><span className="margin-right">Let&#x27;s talk</span><span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></Link></div>
      <div className="col lg-1 no-margin-bottom"></div>
      <div className="col lg-7 no-margin-bottom-lg md-12">
        <div className="container container-nested is-wrapping">
          <div className="col lg-6 md-12 flexh-align-top">
            <div className="c-iconbox1__icon"><img src="http://detheme.com/templates/quaid/images/icon10.svg" alt="" /></div>
            <div className="padding-top">
              <div className="size-h3 on-lg-margin-bottom">Client-Centered Approach</div>
              <div>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor </div>
            </div>
          </div>
          <div className="col lg-6 md-12 md-margin-bottom-small flexh-align-top">
            <div className="c-iconbox1__icon"><img src="http://detheme.com/templates/quaid/images/icon11.svg" alt="" /></div>
            <div className="padding-top">
              <div className="size-h3 on-lg-margin-bottom">True Wealth Management</div>
              <div>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor </div>
            </div>
          </div>
          <div className="col lg-6 md-12 md-margin-bottom-small flexh-align-top">
            <div className="c-iconbox1__icon"><img src="http://detheme.com/templates/quaid/images/icon4.svg" alt="" /></div>
            <div className="padding-top">
              <div className="size-h3 on-lg-margin-bottom">Easy &amp; Efficient Plan Process</div>
              <div>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor </div>
            </div>
          </div>
          <div className="col lg-6 md-12 md-margin-bottom-small flexh-align-top">
            <div className="c-iconbox1__icon"><img src="http://detheme.com/templates/quaid/images/icon7.svg" alt="" /></div>
            <div className="padding-top">
              <div className="size-h3 on-lg-margin-bottom">A Fiduciary Partner</div>
              <div>Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="section no-padding-top-bottom">
    <div className="container">
      <div className="col lg-12 no-margin-bottom">
        <div className="hr"></div>
      </div>
    </div>
  </div>
  <div className="section position-relative">
    <div className="c-shadowtext">Services</div>
    <div className="container position-relative">
      <div className="col block-centered lg-8 md-12 text-align-center position-relative">
        <h2>Dedicated financial services teams</h2>
        <div className="text-medium low-text-contrast">Our work draws on more than 40 years of experience, delivered by 500 professionals in the world&#x27;s most important financial centers.</div>
      </div>
    </div>
    <div className="container">
      <div className="col lg-12 text-align-center">
        <div className="w-layout-grid c-grid2x4">
          <Link to="/" id="w-node-59df5b131331-864b8345" data-w-id="98ccdd70-250e-0aaa-fff0-59df5b131331" className="link-block-2 w-inline-block">
            <div className="c-gridgallery1__content-2">
              <div className="on-dark text-medium weight-is-medium size-h2">Retirement planning</div>
              <div className="on-dark margin-bottom-double">Etiam porta sem malesuada magna mollis euismod. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</div>
            </div>
            <div className="c-gridgallery1__image-2 img3"></div>
          </Link>
          <Link to="/" id="w-node-59df5b13133e-864b8345" data-w-id="98ccdd70-250e-0aaa-fff0-59df5b13133e" className="link-block-2 w-inline-block">
            <div className="c-gridgallery1__content-2">
              <div className="on-dark text-medium weight-is-medium size-h2">Wealth management</div>
              <div className="on-dark margin-bottom-double">Morbi leo risus, porta ac consectetur ac, vestibulum at eros. Aenean eu leo quam. Pellentesque ornare sem lacinia quam </div>
            </div>
            <div className="c-gridgallery1__image-2 img4"></div>
          </Link>
          <Link to="/" id="w-node-59df5b13134b-864b8345" data-w-id="98ccdd70-250e-0aaa-fff0-59df5b13134b" className="link-block-2 w-inline-block">
            <div className="c-gridgallery1__content-2">
              <div className="on-dark text-medium weight-is-medium size-h2">Family investment</div>
              <div className="on-dark margin-bottom-double">Vestibulum id ligula porta felis euismod semper. Sed posuere consectetur est at lobortis.</div>
            </div>
            <div className="c-gridgallery1__image-2 img6"></div>
          </Link>
          <Link to="/" id="w-node-59df5b131358-864b8345" data-w-id="98ccdd70-250e-0aaa-fff0-59df5b131358" className="link-block-2 w-inline-block">
            <div className="c-gridgallery1__content-2">
              <div className="on-dark text-medium weight-is-medium size-h2">Estate planning</div>
              <div className="margin-bottom-double on-dark">Donec ullamcorper nulla non metus auctor fringilla. Cras mattis consectetur purus sit amet fermentum.</div>
            </div>
            <div className="c-gridgallery1__image-2 img5"></div>
          </Link>
        </div>
      </div>
    </div>
  </div>
  <div className="section has-bg-accent position-relative">
    <div className="c-shadowtext">Why us?</div>
    <div className="container margin-bottom-quad">
      <div className="col lg-5 alignself-center md-12">
        <div className="pre-title">Solutions For Every Business</div>
        <h2>Diverse capabilities</h2>
        <p className="low-text-contrast text-medium">Our system is a comprehensive system of applied creativity that connects a process of creative problem solving with skills and tools to make that process work. </p>
        <ul className="c-checklist margin-bottom-double">
          <li className="c-checklist_item">Creative Problem Solving</li>
          <li className="c-checklist_item">Igniting the Conscious and the Subconscious business realities</li>
          <li className="c-checklist_item">The creative new input for developing sustainable business strategies</li>
        </ul>
        <Link data-w-id="8f4d69e5-b8ce-97df-5a1b-3cfdfd580f57" to="/" className="button-primary animated w-inline-block">
          <div style={{WebkitTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 0PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",opacity:1}} className="button-primary-text">View more</div>
          <div style={{opacity:0,"display":"block",WebkitTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 20PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)"}} className="button-primary-text for-hover">let&#x27;s go <span className="fa margin-left"></span></div>
        </Link>
      </div>
      <div className="col lg-1 no-margin-bottom"></div>
      <div className="col lg-6 md-12">
        <div className="w-layout-grid c-services">
          <Link data-w-id="fa761249-6d2b-3e34-3938-d628130e0297" style={{"backgroundColor":"rgb(255,255,255)"}} to="/" className="c-services__card has-shadow has-hover-style-1 w-inline-block">
            <div className="c-services__card-outer">
              <div style={{WebkitTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)","color":"rgb(85,101,117)"}} className="c-services__card-inner"><img src="http://detheme.com/templates/quaid/images/icon9.svg" width="64" alt="" className="margin-bottom" />
                <h4 style={{"color":"rgb(29,43,54)"}} className="c-services__header">Comprehensive Financial Planning</h4>
                <div style={{"color":"rgb(85,101,117)"}} className="margin-bottom is-body-text">Curabitur blandit tempus porttitor donec id elit non </div>
                <div className="iconfont"><em className="iconfont__no-italize"></em></div>
              </div>
            </div>
          </Link>
          <Link data-w-id="7890ee21-a296-58b8-3cc2-d2e7ceddf8ff" style={{"backgroundColor":"rgb(255,255,255)"}} to="/" className="c-services__card has-shadow has-hover-style-1 slidedown w-inline-block">
            <div className="c-services__card-outer">
              <div style={{WebkitTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)","color":"rgb(85,101,117)"}} className="c-services__card-inner"><img src="http://detheme.com/templates/quaid/images/icon1.svg" width="64" alt="" className="margin-bottom" />
                <h4 style={{"color":"rgb(29,43,54)"}} className="c-services__header">Outstanding, Experienced Team</h4>
                <div style={{"color":"rgb(85,101,117)"}} className="margin-bottom is-body-text">Nullam id dolor id nibh ultricies vehicula ut id elit</div>
                <div className="iconfont"><em className="iconfont__no-italize"></em></div>
              </div>
            </div>
          </Link>
          <Link data-w-id="73e38929-1fed-4e43-33b4-534bd46306bf" style={{"backgroundColor":"rgb(255,255,255)"}} to="/" className="c-services__card has-shadow has-hover-style-1 w-inline-block">
            <div className="c-services__card-outer">
              <div style={{WebkitTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)","color":"rgb(85,101,117)"}} className="c-services__card-inner"><img src="http://detheme.com/templates/quaid/images/icon2.svg" width="64" alt="" className="margin-bottom" />
                <h4 style={{"color":"rgb(29,43,54)"}} className="c-services__header">Specialized Attention for Each Client</h4>
                <div style={{"color":"rgb(85,101,117)"}} className="margin-bottom is-body-text">Curabitur blandit tempus porttitor donec id elit non </div>
                <div className="iconfont"><em className="iconfont__no-italize"></em></div>
              </div>
            </div>
          </Link>
          <Link data-w-id="c3535d5d-8c5e-f24f-ac16-fa52fe089ca1" style={{"backgroundColor":"rgb(255,255,255)"}} to="/" className="c-services__card has-shadow has-hover-style-1 slidedown w-inline-block">
            <div className="c-services__card-outer">
              <div style={{WebkitTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MozTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",MsTransform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",transform:"translate3d(0, 80PX, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)","color":"rgb(85,101,117)"}} className="c-services__card-inner"><img src="http://detheme.com/templates/quaid/images/icon8.svg" width="64" alt="" className="margin-bottom" />
                <h4 style={{"color":"rgb(29,43,54)"}} className="c-services__header">Proprietary Tools</h4>
                <div style={{"color":"rgb(85,101,117"}} className="margin-bottom is-body-text">Nullam id dolor id nibh ultricies vehicula ut id elit</div>
                <div className="iconfont"><em className="iconfont__no-italize"></em></div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </div>
  <div className="section no-padding-bottom position-relative">
    <div className="container">
      <div className="col lg-12 no-margin-bottom no-padding-lr">
        <div data-delay="3000" data-animation="slide" data-autoplay="1" data-easing="ease-out-quint" data-duration="1500" data-infinite="1" className="c-slider w-slider">
          <div className="w-slider-mask">
            <div className="w-slide">
              <div className="container flexh-align-center">
                <div className="col no-margin-bottom lg-6 md-12 order-last"><img src="http://detheme.com/templates/quaid/images/57356.png" width="320" alt="" /></div>
                <div className="col lg-1"></div>
                <div className="col no-margin-bottom lg-5 position-relative md-12">
                  <div className="text-large weight-is-thin margin-bottom">Every financial decision involves relationships. Every relationship involves financial decisions.</div>
                  <div className="is-bold">Johny Baldon</div>
                  <div className="text-small">CEO at Turus Berkarya</div>
                  <div className="c-quote__marker">“</div>
                </div>
              </div>
            </div>
            <div className="w-slide">
              <div className="container flexh-align-center">
                <div className="col no-margin-bottom lg-6 md-12 order-last"><img src="http://detheme.com/templates/quaid/images/smile.png" alt="" /></div>
                <div className="col lg-1"></div>
                <div className="col no-margin-bottom lg-5 position-relative md-12">
                  <div className="text-large weight-is-thin margin-bottom">Very happy with our new website very quick turnaround and excellent customer service</div>
                  <div className="is-bold">Christian Soilo</div>
                  <div className="text-small">Managing Director @Semanding</div>
                  <div className="c-quote__marker">“</div>
                </div>
              </div>
            </div>
            <div className="w-slide">
              <div className="container flexh-align-center">
                <div className="col no-margin-bottom lg-6 md-12 order-last"><img src="http://detheme.com/templates/quaid/images/27969.png" width="287" alt="" /></div>
                <div className="col lg-1"></div>
                <div className="col no-margin-bottom lg-5 position-relative md-12">
                  <div className="text-large weight-is-thin margin-bottom">I would highly recommend them! They always treat my business as if she was one of theirs!</div>
                  <div className="is-bold">Baharuddin Muamari</div>
                  <div className="text-small">Executive Producer @Joyoboyo</div>
                  <div className="c-quote__marker">“</div>
                </div>
              </div>
            </div>
          </div>
          <div className="hidden w-slider-arrow-left">
            <div className="w-icon-slider-left"></div>
          </div>
          <div className="hidden w-slider-arrow-right">
            <div className="w-icon-slider-right"></div>
          </div>
          <div className="c-slider__nav w-slider-nav w-slider-nav-invert w-round"></div>
        </div>
      </div>
    </div>
    <div className="c-shadowtext">clients<br/>say</div>
  </div>
  <div className="section has-bg-accent position-relative">
    <div className="container">
      <div className="col block-centered lg-10 md-12">
        <div className="c-financial-finder text-align-center">
          <div className="pre-title">Ready to start a conversation?</div>
          <h2 className="text-align-center md-size-h3">Find a Financial Advisor Near You</h2>
          <div className="text-align-center margin-bottom">Filter by investment need, ZIP code or view all Financial advisors.</div>
          <div className="w-form">
            <Form id="email-form-2" name="email-form-2" data-name="Email Form 2" className="c-horizontal-form"><select id="field" name="field" className="form-select no-margin-bottom-lg md-margin-bottom w-select"><option value="Select investment need">Select investment need</option><option value="Tax planning">Tax planning</option><option value="Estate planning">Estate planning</option><option value="Retirement planning">Retirement planning</option></select><input type="text" className="form-input-text no-margin-bottom-lg margin-left margin-right md-no-margin-lr w-input" maxlength="256" name="Zip-code" data-name="Zip code" placeholder="Enter Zip code" id="Zip-code" required="" /><input type="submit" value="Go" data-wait="Please wait..." className="button-primary min-width-70 w-button" /></Form>
            <div className="w-form-done">
              <div>Thank you! Your submission has been received!</div>
            </div>
            <div className="w-form-fail">
              <div>Oops! Something went wrong while submitting the form.</div>
            </div>
          </div>
          <div className="text-xsmall text-align-center low-text-contrast">Check the background of Our Firm and Investment Professionals on <Link to="/">FINRA&#x27;s Broker/Check</Link>.</div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="col lg-12">
        <div className="w-layout-grid c-grid4x2">
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
          <div className="fa-brand _70px"></div>
        </div>
      </div>
    </div>
    <div className="c-shadowtext">Advisor<br/>finder</div>
  </div>
  <div className="section">
    <div className="container">
      <div className="col lg-6 md-12">
        <h2>Our impact in numbers</h2>
      </div>
      <div className="col lg-1 hidden-md"></div>
      <div className="col lg-3 md-6 xs-12">
        <div>Fusce dapibus maaecenas faucibus mollis interdumb </div>
      </div>
      <div className="col lg-3 md-6 xs-12">
        <div>Fusce dapibus lorem tellus ac cursus commodo ipsum</div>
      </div>
    </div>
    <div className="container">
      <div className="col lg-3 md-6 xs-12">
        <div className="c-counter has-shadow is-featured">
          <div className="flexh-space-between flexh-align-center margin-bottom">
            <div className="weight-is-medium">ROI</div><img src="http://detheme.com/templates/quaid/images/number-1.svg" width="32" alt="" /></div>
          <div className="text-xlarge text-align-center">28%</div>
          <div className="text-align-center text-small">micro &amp; macro indicators</div>
        </div>
      </div>
      <div className="col lg-3 md-6 xs-12">
        <div className="c-counter has-shadow">
          <div className="flexh-space-between flexh-align-center margin-bottom">
            <div className="weight-is-medium">Portfolio</div><img src="http://detheme.com/templates/quaid/images/icon6_1.svg" width="32" alt="" /></div>
          <div className="text-xlarge text-align-center is-heading-color">$17 <span className="text-small">Billion</span></div>
          <div className="text-align-center text-small">of sucessful investment</div>
        </div>
      </div>
      <div className="col lg-3 md-6 xs-12">
        <div className="c-counter has-shadow">
          <div className="flexh-space-between flexh-align-center margin-bottom">
            <div className="weight-is-medium">Hedgefund</div><img src="http://detheme.com/templates/quaid/images/icon12.svg" width="32" alt="" /></div>
          <div className="text-xlarge text-align-center is-heading-color">928</div>
          <div className="text-align-center text-small">business partnerships</div>
        </div>
      </div>
      <div className="col lg-3 md-6 xs-12">
        <div className="c-counter has-shadow">
          <div className="flexh-space-between flexh-align-center margin-bottom">
            <div className="weight-is-medium">Experience</div><img src="http://detheme.com/templates/quaid/images/people.svg" width="32" alt="" /></div>
          <div className="text-xlarge text-align-center is-heading-color">17 <span className="text-small">Years</span></div>
          <div className="text-align-center text-small">of succesful investing</div>
        </div>
      </div>
    </div>
  </div>
  <div className="section no-padding-top-bottom">
    <div className="container is-wide">
      <div className="col lg-12 no-margin-bottom">
        <div className="c-imageblock-link img2">
          <div className="container container-nested h100">
            <div className="col lg-8 md-12"></div>
            <div className="col no-margin-bottom lg-4 md-12 is-body-text-color">
              <div className="c-imageblock-link__text margin-bottom">Discover Financia online and mobile feature and access capabilities</div>
              <div className="margin-bottom-double on-dark">Our online capabilities help you stay informed about your investments and manage your everyday finances.</div><Link to="/" className="cta-link on-dark"><span className="margin-right">Learn more</span> <span className="fa c-cta1_arrow-hovered"></span> <span className="fa c-cta1__arrow-normal"></span></Link></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div className="section position-relative">
    <div className="container">
      <div className="col lg-7 md-12 block-centered text-align-center">
        <div className="pre-title">From our blog</div>
        <h2>Latest news and articles</h2>
      </div>
    </div>
    <div className="container">
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><img src="http://detheme.com/templates/quaid/images/gratisography-358H.jpg"  sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" className="c-gridpost__image"/>
          <div className="c-gridpost__category style3"><Link to="/" className="c-gridpost__category-link">finance</Link> / <Link to="/" className="c-gridpost__category-link">investment</Link></div>
          <Link to="/" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">What I’ve Learned Working In Finance For Six Years</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><img src="http://detheme.com/templates/quaid/images/gratisography-346H.jpg" sizes="(max-width: 479px) 90vw, (max-width: 767px) 93vw, (max-width: 991px) 95vw, 29vw" alt="" className="c-gridpost__image"/>
          <div className="c-gridpost__category style3"><Link to="/" className="c-gridpost__category-link">Wealth</Link> / <Link to="/" className="c-gridpost__category-link">retirement plan</Link></div>
          <Link to="/" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">The New Rules of Personal Finance in Wealth Management</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </Link>
        </div>
      </div>
      <div className="col lg-4 md-12">
        <div className="c-gridpost__card"><img src="http://detheme.com/templates/quaid/images/gratisography-278H.jpg" alt="" className="c-gridpost__image"/>
          <div className="c-gridpost__category style3"><Link to="/" className="c-gridpost__category-link">management</Link> / <Link to="/" className="c-gridpost__category-link">family</Link></div>
          <Link to="/" className="c-gridpost__clickable w-inline-block">
            <div className="c-gridpost__text style2">
              <h3 className="margin-bottom">Thoughts from Crypto Finance Conference in Swiss 2020</h3>
              <div className="text-small low-text-contrast">07 June 2020</div>
            </div>
          </Link>
        </div>
      </div>
    </div>
    <div className="c-shadowtext">blog</div>
  </div>
  

            </div>
        )
    }
}

export default Home
